import { render, staticRenderFns } from "./ModalDocking.vue?vue&type=template&id=44705d9d&scoped=true"
import script from "./ModalDocking.vue?vue&type=script&lang=js"
export * from "./ModalDocking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44705d9d",
  null
  
)

export default component.exports